const memoize = func => {
    let cache = new Map();
    const memoized = (...args) => {
        let key = JSON.stringify(args.slice(1));
        if (cache.has(key)) {
            return cache.get(key);
        }
        let result = func.apply(this, args);
        cache.set(JSON.stringify(key), result);
        return result;
    };
    return memoized;
}

export const currencyFormat = memoize(() => {
    return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency:  'TRY',
        minimumFractionDigits: 2,
    });
})